import { Box, colors } from '@mui/material';
import { styled } from '@mui/system';

export const IconBoxWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: colors.blue[50],
  width: theme.spacing(6),
  height: theme.spacing(6),
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  flexBasis: 'auto',
  flexShrink: 0,
  justifyContent: 'center'
}));
